import { QRCode } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { cx } from '@/Ship/Helpers/cssClass'

import { QR_VISIBLE_STATUSES } from './Constants'
import { QRSectionStore } from './QRSectionStore'

import styles from './Drawer.module.css'

import type { AssignmentItem } from './Types'

interface QRSectionProps {
    assignment: AssignmentItem
}

/** QR-код завдання для охорони: доступний лише під час виконання */
export const QRSection = observer(({ assignment }: QRSectionProps) => {
    const [store] = useState(() => new QRSectionStore())

    const canShow = QR_VISIBLE_STATUSES.includes(assignment.status)
    const isDone = assignment.status === 'completed_by_driver' || assignment.status === 'completed_by_dispatcher'
    const qrValue = `assignment:${assignment.uuid}`

    if (isDone || !canShow) {
        return (
            <div className={cx(styles, 'row')}>
                <span className={cx(styles, 'rowLabel')}>QR-код</span>
                <span className={cx(styles, 'rowHint')}>
                    {isDone ? 'Завдання завершено' : 'Буде сформований після початку виконання'}
                </span>
            </div>
        )
    }

    return (
        <>
            <div className={cx(styles, 'row')}>
                <span className={cx(styles, 'rowLabel')}>QR-код</span>
                <button
                    type="button"
                    className="pwa-btn pwa-btn--secondary pwa-btn--compact"
                    onClick={() => store.toggle()}
                >
                    {store.show ? 'Приховати' : 'Показати'}
                </button>
            </div>
            {store.show && (
                <div className={cx(styles, 'qrWrap')}>
                    <div className={cx(styles, 'qrFrame')}>
                        <QRCode value={qrValue} size={208} color="#000" bgColor="#fff" />
                    </div>
                </div>
            )}
        </>
    )
})
